/**
 * LDM · Página de CINCO
 * ---------------------------------------------------------------------------
 * - Rieles con flechas y puntos (formas de tomarlo, reseñas).
 * - Modal de la ficha técnica sobre <dialog>.
 * - Movimiento continuo ligado al scroll: cada elemento con `data-ldm-mov` se
 *   desplaza según dónde esté en la pantalla, en los dos sentidos. Nada nace
 *   oculto: sin este archivo la página se ve completa, solo quieta.
 * - Las estrellas del Buy Box llevan a las reseñas.
 *
 * Se puede cargar desde varias secciones: la guarda evita iniciar dos veces.
 */
(function () {
  'use strict';
  if (window.__ldmCinco) return;
  window.__ldmCinco = true;

  var QUIETO =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function listo(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- Rieles --------------------------------------------------------- */
  function iniciarRiel(riel) {
    var raiz = riel.closest('[data-ldm-riel-raiz]') || riel.parentElement;
    var prev = raiz.querySelector('[data-ldm-prev]');
    var next = raiz.querySelector('[data-ldm-next]');
    var puntos = raiz.querySelector('[data-ldm-puntos]');
    var n = riel.children.length;
    var marcas = [];

    if (puntos) {
      for (var i = 0; i < n; i++) {
        var p = document.createElement('i');
        puntos.appendChild(p);
        marcas.push(p);
      }
    }

    function paso() {
      var card = riel.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : 240;
    }

    function actualizar() {
      var max = riel.scrollWidth - riel.clientWidth;
      if (prev) prev.disabled = riel.scrollLeft <= 4;
      if (next) next.disabled = riel.scrollLeft >= max - 4;
      if (marcas.length) {
        var idx = max > 0 ? Math.round((riel.scrollLeft / max) * (n - 1)) : 0;
        marcas.forEach(function (m, k) { m.classList.toggle('is-activo', k === idx); });
      }
    }

    if (prev) prev.addEventListener('click', function () { riel.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { riel.scrollBy({ left: paso(), behavior: 'smooth' }); });
    riel.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar, { passive: true });
    actualizar();
  }

  /* ---- Modal de la ficha ---------------------------------------------- */
  function iniciarModales() {
    document.querySelectorAll('[data-ldm-abrir-modal]').forEach(function (btn) {
      var modal = document.getElementById(btn.getAttribute('data-ldm-abrir-modal'));
      if (!modal || typeof modal.showModal !== 'function') return;
      btn.addEventListener('click', function () { modal.showModal(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
      modal.querySelectorAll('[data-ldm-cerrar-modal]').forEach(function (c) {
        c.addEventListener('click', function () { modal.close(); });
      });
    });
  }

  /* ---- Estrellas del Buy Box → reseñas -------------------------------- */
  function iniciarEstrellas() {
    var destino = document.getElementById('resenas');
    if (!destino) return;
    document.querySelectorAll('.product .loox-rating').forEach(function (el) {
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      function ir(e) {
        e.preventDefault();
        destino.scrollIntoView({ behavior: QUIETO ? 'auto' : 'smooth', block: 'start' });
      }
      el.addEventListener('click', ir);
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') ir(e); });
    });
  }

  /* ---- Movimiento continuo -------------------------------------------- */
  function iniciarMovimiento() {
    if (QUIETO) return;
    var moviles = Array.prototype.slice.call(document.querySelectorAll('[data-ldm-mov]'));
    if (!moviles.length) return;
    var pendiente = false;

    function pintar() {
      var vh = window.innerHeight;
      for (var i = 0; i < moviles.length; i++) {
        var el = moviles[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -160 || r.top > vh + 160) continue;
        var factor = parseFloat(el.getAttribute('data-ldm-mov')) || 0.1;
        var centro = r.top + r.height / 2;
        var avance = (centro - vh / 2) / (vh / 2 + r.height / 2);
        if (avance > 1) avance = 1;
        else if (avance < -1) avance = -1;
        el.style.transform = 'translate3d(0,' + (avance * factor * 100).toFixed(2) + 'px,0)';
      }
      pendiente = false;
    }

    function alScroll() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(pintar);
    }
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    pintar();
  }

  /* ---- Videos que arrancan solos al verse --------------------------- */
  function iniciarVideos() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-ldm-auto]'));
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.preload = 'metadata'; v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          v.play().catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
  }

  listo(function () {
    document.querySelectorAll('[data-ldm-riel]').forEach(iniciarRiel);
    iniciarModales();
    iniciarEstrellas();
    iniciarMovimiento();
    iniciarVideos();
  });
})();
